<template>
  <div class="calling-container">
    <div class="phone-info">
      <div class="avatar-container">
        <img src="../../assets/logo.png" alt="logo">
      </div>
      <div v-show="!unknownNumber" class="info-container">
        <div class="title">{{destinationInfo.name}}</div>
        <div class="phone-number">{{destinationInfo.phoneNumber}}</div>
      </div>
      <div v-show="unknownNumber" class="unknown-number-container">
        <div class="phone-number">{{softphone.phoneNumber}}</div>
      </div>
    </div>
    <div class="status-container">
      <div class="status" v-if="callState === state.CREATED">
        Đang gọi...
      </div>
      <div v-if="callState === state.ANSWERED">
        {{ time | countime_up }}
      </div>
      <div class="d-flex flex-column justify-content-center">
        <h2 v-if="callResult === result.BUSY" class="text-red align-items-center">Máy bận</h2>
        <div v-if="callState === state.HANGUP">
          <b>{{time | countime_up}}</b> Kết thúc cuộc gọi
        </div>
      </div>
    </div>
    <div class="decline-btn">
      <button class="keypad-cancel" @click="cancelAction()">
        <i class="fa fa-phone" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</template>

<script>
import ity from '../../lib/ity'
import {CALL_STATE, CALL_OUT_RESULT} from '../../common/constant'
import {mapGetters} from 'vuex'
import callCenterAPI from '../../api/callCenter'
import sound from '../../assets/hangup.mp3'

export default {
  name: 'Callout',
  props: {
    cancel: {
      type: Function,
      required: true
    },
  },
  computed: {
    ...mapGetters([
      'softphone'
    ]),
    callState () {
      return ity.callState
    },
    callResult () {
      return ity.callOutResult
    }
  },
  data () {
    return {
      state: CALL_STATE,
      result: CALL_OUT_RESULT,
      unknownNumber: true,
      destinationInfo: {
        name: '',
        phoneNumber: ''
      },
      time: 0,
      interval: null
    }
  },
  watch: {
    callState: {
      handler: function () {
        if (this.callState === CALL_STATE.CREATED) {
          this.reset()
        }

        if (this.callState === CALL_STATE.ANSWERED) {
          this.interval = setInterval(this.incrementTime, 1000)
        }
        if (this.callState === CALL_STATE.HANGUP) {
          clearInterval(this.interval)
          var audio = new Audio(sound)
          audio.play()
          setTimeout(() => {
            // this.cancel()
            this.reset()
          }, 3000)
        }
      }
    },
  },
  methods: {
    reset () {
      this.time = 0
      this.interval = null
    },
    cancelAction () {
      this.cancel()
      callCenterAPI.end_callout({phone: this.softphone.phoneNumber}).then(res => {}).catch(() => {})
    },
    incrementTime () {
      this.time = parseInt(this.time) + 1
    },
  },
}
</script>

<style scoped lang="scss">
.calling-container {
  padding-top: 20px;
  width: 400px;;
  .phone-info {
    display: flex;
    flex-direction: row;
    margin: 20px;

    .avatar-container {
      img {
        height: 100px;
        width: 100px;
        border-radius: 100px;
      }
      margin-right: 20px;
    }

    .info-container {
      display: flex;
      flex-direction: column;

      .title {
        font-size: 24px;
        font-weight: bold;
      }

      .phone-number {
        font-size: 20px;
      }
    }

    .unknown-number-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 24px;
    }
  }

  .status-container {
    height: 215px;
    display: flex;
    justify-content: center;
    align-items: center;

    .status {
      font-weight: bold;
      animation: crescendo 1.5s alternate infinite ease-in;
    }

    @keyframes crescendo {
      0%   {transform: scale(1);}
      100% {transform: scale(1.3);}
    }
  }

  .decline-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;

    .keypad-cancel {
      height: 70px;
      width: 70px;
      margin: 5px;
      border-radius: 33px;
      font-size: 24px;
      background-color: #e14858;
      border: none;
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/telephone/CallOut.vue